<template>
   <el-tooltip effect="light" popper-class="tsa-custom-tooltipV2" :content="message" placement="top">
        <slot></slot>
    </el-tooltip>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-tooltipV2 {

    }
</style>